<template>
	<div class="pt-2">
		<CommonFlame :title="title">
			<ValidationError :errors="errors" />
			<DeliveryOrderForm
				:delivery_order.sync="delivery_order"
				:infos_by_full_address.sync="infosByFullAddress"
				:suppliers="suppliers"
				:car_models="car_models"
				:shipping_places="shipping_places"
				:selected_quote_request="selectedQuoteRequest"
				@submit-form="submitForm($event)"
				@set-deleted-attributes="setDeletedAttributes($event)"
			/>
		</CommonFlame>
	</div>
</template>

<script>
import axios from "axios"
import moment from "moment"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import common from "../../helper/common"
import CommonFlame from "../shared/CommonFlame.vue"
import ValidationError from "../shared/ValidationError.vue"
import DeliveryOrderForm from "./components/DeliveryOrderForm.vue"

export default {
	components: {
		CommonFlame,
		ValidationError,
		DeliveryOrderForm,
	},
	data() {
		return {
			title: "配車依頼書",
			id: this.$route.params.id,
			delivery_order: {
				price: null,
				order_date: moment().format("YYYY-MM-DD"),
				number_of_cars: null,
				car_model: null,
				pic_name: null,
				shipping_place_id: null,
				memo: null,
				supplier_id: null,
				quote_request_id: null,
				send_by_fax: false,
				delivery_order_individual_infos_attributes: [],
			},
			infosByFullAddress: [
				{
					full_address: "",
					delivery_info: {
						zipcode: "",
						prefecture: "",
						city: "",
						address: "",
						fax: "",
						phone: "",
						company_name: "",
						person_name: "",
						deadline: "",
						deadline_time: "",
						shipping_date: "",
					},
					infos: [],
				},
			],
			deletedAttributes: [],
			suppliers: [],
			shipping_places: [],
			car_models: [],
			selectedQuoteRequest: null,
			statusType: "draft",
			errors: [],
			common,
		}
	},
	mounted() {
		this.fetchDeliveryOrder()
	},
	methods: {
		fetchDeliveryOrder() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/delivery_orders/${this.id}/edit`
			axios
				.get(url, { headers })
				.then((res) => {
					this.suppliers = res.data.suppliers
					this.shipping_places = res.data.shipping_places
					this.car_models = res.data.car_models
					this.setDeliveryOrder(res.data.delivery_order)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		setDeliveryOrder(delivery_order) {
			this.selectedQuoteRequest = delivery_order.quote_request
			this.statusType = delivery_order.status_type
			this.delivery_order = {
				price: delivery_order.price,
				order_date: delivery_order.order_date,
				pic_name: delivery_order.pic_name,
				shipping_place_id: delivery_order.shipping_place_id,
				memo: delivery_order.memo,
				supplier_id: delivery_order.supplier_id,
				quote_request_id: delivery_order.quote_request_id,
				send_by_fax: delivery_order.send_by_fax,
				delivery_order_cars_attributes: delivery_order.delivery_order_cars.map((d) => {
					return {
						id: this.statusType != "sent" ? d.id : null,
						car_model: d.car_model,
						number_of_cars: d.number_of_cars,
						price: d.price,
					}
				}),
			}
			this.infosByFullAddress = delivery_order.delivery_order_individual_infos.reduce(
				(groups, current) => {
					const group = groups.find(
						(group) =>
							group.full_address === `${current.prefecture}${current.city}${current.address}`
					)
					if (group) {
						group.infos.push(current.order_individual_info)
						if (this.statusType != "sent")
							group.delivery_order_individual_infos.push({
								id: current.id,
								order_individual_info_id: current.order_individual_info.id,
							})
					} else {
						groups.push({
							full_address: `${current.prefecture}${current.city}${current.address}`,
							delivery_info: {
								zipcode: current.zipcode,
								prefecture: current.prefecture,
								city: current.city,
								address: current.address,
								fax: current.fax,
								phone: current.phone,
								company_name: current.company_name,
								person_name: current.person_name,
								deadline: current.deadline,
								deadline_time: current.deadline_time
									? moment(current.deadline_time).format("HH:mm")
									: null,
								shipping_date: current.shipping_date,
							},
							infos: [current.order_individual_info],
							delivery_order_individual_infos:
								this.statusType != "sent"
									? [{ id: current.id, order_individual_info_id: current.order_individual_info.id }]
									: null,
						})
					}
					return groups
				},
				[]
			)
		},
		setDeletedAttributes(attributes) {
			this.deletedAttributes = this.deletedAttributes.concat(attributes)
		},
		submitForm(status) {
			let delivery_order_individual_infos_attributes = this.infosByFullAddress
				.map((infoByAddress) => {
					return infoByAddress.infos.map((d) => {
						let deliveryOrderIndividualInfo = infoByAddress.delivery_order_individual_infos
							? infoByAddress.delivery_order_individual_infos.find(
									(i) => i.order_individual_info_id == d.id
							  )
							: null
						return {
							id: deliveryOrderIndividualInfo?.id,
							order_individual_info_id: d.id,
							...infoByAddress.delivery_info,
						}
					})
				})
				.flat()
			delivery_order_individual_infos_attributes =
				delivery_order_individual_infos_attributes.concat(this.deletedAttributes)
			const headers = authenticate.setHeader()
			const url = `/erp/v1/delivery_orders/${this.id}`
			axios
				.put(
					url,
					{
						delivery_order: {
							...this.delivery_order,
							status_type: status,
							delivery_order_individual_infos_attributes,
						},
					},
					{ headers }
				)
				.then((res) => {
					let message
					let route
					if (this.statusType != "sent" && res.data.status_type == "draft") {
						message = "配車依頼書の下書きを更新しました。"
						route = { name: "delivery_order_index" }
					} else if (this.statusType == "sent" && res.data.status_type == "draft") {
						message = "配車依頼書の下書きを作成しました。"
						route = { name: "delivery_order_index" }
					} else if ((this.statusType == 'pending' || this.statusType == 'rejected') && res.data.status_type == "pending") {
						message = "配車依頼書を更新し、確認依頼メッセージを送信しました。"
						route = { name: "delivery_order_show", params: { id: res.data.id } }
					} else if (res.data.status_type == "pending") {
						message = "配車依頼書を作成し、確認依頼メッセージを送信しました。"
						route = { name: "delivery_order_show", params: { id: res.data.id } }
					} else if (res.data.status_type == "sent") {
						message = "配車依頼書を作成しました。"
						route = { name: "delivery_order_show", params: { id: res.data.id } }
					}

					this.$store.dispatch("setFlash", {
						type: "notice",
						text: message,
					})
					this.$router.push(route)
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
	},
}
</script>